import React from "react";

const THead = ({ properties, sortType, setSortType }) => {
    const handleSortClick = (field) => {
        setSortType(prev => {
            const prevSort = prev.sortSettings[field] ?? false;
            return {
                currentField: field,
                sortSettings: {
                    ...prev.sortSettings,
                    [field]: !prevSort
                }
            };
        });
    };

    return (
        <thead>
        <tr>
            {properties.map((p, i) => (
                <td key={i}>
                    {p.label}
                    {p.sortable && (
                        <button onClick={() => handleSortClick(p.key)}>
                            {
                                sortType.currentField === p.key
                                    ? sortType.sortSettings[p.key] ? '▲' : '▼'
                                    : '⇅'
                            }
                        </button>
                    )}
                </td>
            ))}
        </tr>
        </thead>
    );
};

export default THead;